import { z } from 'zod'
import { ProgramThreshold, Currency } from '~library/enums'
import { dateValueSchema } from '~library/models'
import { travelAmountStatisticsProgramFeedbackSchema } from './travel-amount-statistics-program-feedback'

/** 本次合約期間開票量方案資料 Schema */
export const invoicingVolumeInformationSchema = z.object({
  /** 方案名稱[英文] */
  englishName: z.string(),
  /** 方案名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 方案名稱[繁體中文] */
  traditionalName: z.string(),
  /** 檻次 */
  threshold: z.nativeEnum(ProgramThreshold),
  /** 幣別 */
  currency: z.nativeEnum(Currency),
  /** 總金額 */
  amount: z.number(),
  /** 起始日期 */
  startTime: dateValueSchema,
  /** 截止日期 */
  endTime: dateValueSchema,
  /** 方案回饋 */
  programFeedback: z.array(travelAmountStatisticsProgramFeedbackSchema)
})

/** 本次合約期間開票量方案資料 */
export interface InvoicingVolumeInformation
  extends z.infer<typeof invoicingVolumeInformationSchema> {}
